import { Customer } from 'components/analytics/customer/Customer'
import { useLocation, useSearchParams } from 'react-router-dom'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'
import { INITIAL_ADVANCE_FILTER, INITIAL_DATA_FILTER } from 'configs/analytics/configTableCustomer'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_CUSTOMER } from 'services/apiAnalyticCustomer'
import { Alert } from 'avo-ui'

export const CustomerContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [queryFilter, setQueryFilter] = useState(INITIAL_ADVANCE_FILTER)
    const [queryList, setQueryList] = useState({})
    const { fetching: getCustomerList, data: customerList, isLoading: isLoadingList } = useFetch(API_CUSTOMER.LIST)
    const { fetching: exportCustomerList, isLoading: isLoadingExport } = useFetch(API_CUSTOMER.EXPORT)
    const [modal, setModal] = useState({
        filter: false,
        export: false,
    })

    useEffect(() => {
        const currentQuery = { ...query, page: Number(query?.page), limit: Number(query?.limit) }
        const newQueryFilter = { ...INITIAL_ADVANCE_FILTER }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (key === 'cities') {
                const splitObject = item?.split('|')
                const parseObject = splitObject?.map((i) => JSON.parse(i))
                newQueryFilter[key] = parseObject
                currentQuery[key] = parseObject?.map((i) => i?.value)
            }
        })
        setQueryFilter({ ...queryFilter, ...newQueryFilter })
        setQueryList(currentQuery)
        getCustomerList(currentQuery)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const onFilter = (filter) => {
        const queryFilter = getQueryAdvanceFilter(filter)
        onChangeQuery({ ...queryFilter, page: 1 })
        setShowModal({ filter: false })
    }

    const getQueryAdvanceFilter = (filter) => {
        const queryFilter = { ...filter }
        Object.entries(queryFilter).forEach(([key, item]) => {
            const mapData = item.map((i) => JSON.stringify(i))
            queryFilter[key] = mapData.join('|')
        })
        return queryFilter
    }

    const onSelectSort = (value) => {
        const splitSort = value?.split('_')
        onChangeQuery({ order_by: splitSort[0], order_type: splitSort[1] })
    }

    const onExport = () => {
        const { page, limit, ...queryRest } = queryList
        exportCustomerList(queryRest, '', {}, 'blob').then((response) => {
            downloadFile(
                null,
                response,
                `Analytic-Customer-Export-Start_${query?.start_date}-End_${query?.end_date}.xlsx`,
            )
            setShowModal({ export: false })
            return Alert({
                icon: 'success',
                title: 'Success',
                message: 'Analytic Customer Exported',
            })
        })
    }

    const props = {
        dataList: customerList?.data,
        query,
        onChangeQuery,
        queryFilter,
        onFilter,
        modal,
        setShowModal,
        onSelectSort,
        isLoadingList,
        isLoadingExport,
        onExport,
    }

    return <Customer {...props} />
}
